export default {
  menus: {
    index: "Dashboard",
    Customer: "Customer",
    Order: "Order Status",
    OrderStatus: "Order Status",
    Report: "Report",
    ExportDeliveryReport:"Production and Shipping Performance Analysis",
    InventoryReport:'Inventory Report',
    SalesReports:'Sales Report',
    FinanceReports:'Financial Report',
    LeaderboardReport:'Ranking',
    ExReservationInvitationSummaryForBusiness:"Market Invited Customer Summary Table",
    ExReservationTabs:'Market Invited Customer Detailed List',
    ReportOne: "Net Sales Revenue Analysis",
    ReportTwo: "Overdue Account Receivables",
    ReportThree: "Order Intake and Shipped Report",
    ReportFour: "Customer Container Tracking Report（Surcharge）",
    ReportFive: "Inventory Age Report",
    ReportSix: "Export Sales Analysis Per Customer",
    ReportSeven: "Export Sales Analysis Per Cover No",
    ReportEight: "Export Sales Analysis Per Model",
    ReportNine: "Sales Detail Report",
    ReportTen: "Service Order Status Report",
    ReportTwentyV2:'Customer Product Display & Competing Product Status',
    vpsalesMezzanine:"Competitors Customer Summary Table",
    newCompetions:'Competions',
    CompetitiveProductAnalysisDataList:"Competing Products Customer Detailed List",
    ReportEleven: "Statement Of Business Shipments And Revenues",
    ReportTwenty: "Customer Line Up & Competition Summary",
    qsInventory:"Ship-A-Ton Inventory Report",
    relatingPrices:"Prices",
    Travel: "Travel",
    competitors: "Company Competitior",
    competingGoods: "Pricelists",
    exhibition: "Markets",
    Commitments: "Markets List",
    tableListbyCustomer: "Commitments List",
    tableList: "Summary by Customer",
    TotalCommitments: "Summary by Model",
    Video: "Video",
    Documents: "Documents",
    Catalog: "Documents",
    achievement: "Performance",
    resetPassword: "Reset Password",
    Performance: "Sales Review",
    others: "Others",
    DFSEDIInvolce: "DFS EDI Involce",
    lmageVideo: "Images&Video",
    Cover: "Covers",
    CoverFeature: "Cover Feature",
    Admin: "Admin",
    Frames: "Frames",
    CoversRelated: "Covers Related",
    ContentRelated: "Content Related",
    Models: "Models List",
    modelsManager: "Models",
    Arms: "Arms",
    Backs: "Backs",
    Categories: "Categories",
    Features: "Features",
    Mechanisms: "Mechanisms",
    Seats: "Seats",
    SKU: "SKU",
    Styles: "Styles",
    Arrangements: "Arrangements",
    Covers: "Covers",
    CoversGrades: "Cover Grades",
    CoversGroups: "Cover Groups",
    Photos: "Photos",
    Videos: "Videos",
    Price: "Price",
    InventoryPlatform: "Inventory Platform",
    InventoryPlatformProductInfoConfig: "Product Information",
    InventoryPlatformCustomerData: "Customer Data",
    InventoryPlatformSharingReport: "Inventory Sharing Report",
    // InventoryReport: "Order intake statement",
    RevenueReport: "Sales Revenue Shipping Report",
    InventoryPlatformCustomerDataNew: "Customer Data",
    NewStyleMaintenance: "New Model Maintain",
    ExhibitionBonusDistribution: "Exhibition Bonus Distribution",
    ExhibitionBonusStyles: "Exhibition Bonus Styles",
    SpecificationRelationship: "Specification Relationship",
    FollowUpSituationTable: "Market Order Statement",
    ConfirmOrderDetails: "Market Confirmed Order Details",
    MarketNewModelBonusReport: "Market New Model Bonus Report",
    NewModelRelated: "New Model Related",
    ExReservation: "Market Reservation",
    CustomerManagement: "Customer Management",
    CustomerSalesInfo: "Customer Information Management",
    cart: "Check List",
    poList: "PO List",
    OrderAverageDeliveryTime: "Customer Order Average Delivery",
    OrderDeliveryTimeOverview: 'Delivery Time Overview',
    OrderDeliveryTimeDetail: 'Delivery Time Detail',
    CompetitiveProductAnalysis:'Customer Competitors',
    newCP:'Company Competitors',
    OrderIntake: 'Open order intake',
    ProductRecommendation: 'Competitive Information',
    MainPushStyleSalesRanking: 'Model Sales Ranking',
    ContainerDimensions: 'Container Dimensions',
    AccountHierarchySettings: 'Account Hierarchy Settings',
    ExReservationInvitationSummary: 'Market Reservation',
    ToDoReminder: 'To-do Items',
    newPrices: "Prices",
    quotationSheet:"quotationSheet",
    rai:"Resignation Succession",
    mwhCompetitorFeatures:"Competitors Features",
    Competitorslist:"Competitor Related",
    loginlog:"Login Logs",
    Account:"Account"
  },
  others: {
    DFSEDIInvolce: {
      lnvoiceCode: "invoice Code",
      ExportEDIFile: "Export EDI File",
      EDIFileName: "EDI File Name",
      ExportPOFile: "Export POFile",
    },
  },
  dash: {
    Year: "Year",
  },
  Home: {
    Department: "Department",
    OverdueAmount: "Overdue Amount",
    SaleAmount: "Sales Amount",
    charTitle1: "Monthly Sales YoY",
    charTitle2: "Order Intake and Shipped Report",
    charTitle3: "Customer Sales Ranking",
    charTitle4: "Top Customers by Overdue Amount",
    charTitle5: "My Best Selling Models",
    charTitle6: "Department’s Best Selling Models",
    charTitle7: "My Best Selling Covers",
    charTitle8: "Department’s Best Selling Covers",
    tbTitle1: "Customer Name",
    tbTitle2: "Current Month's Sales",
    tbTitle3: "Same Month Last Year's Sales",
    tbTitle4: "Account Receivable",
    tbTitle5: "Growth Ratio%",
    more: "more",
    lastYear: "Last Year",
    thisYear: "This Year",
    color:'Color',
    money:'Money',
    radio:'Radio'
  },
  menusObj: {
    menu_title1: "Dashboard",
    menu_title2: "Customer",
    menu_title3: "Order Status",
    menu_title4: "Report",
    menu_title5: "Travel",
    menu_title6: "Company Competitior",
    menu_title7: "Pricelist",
    menu_title8: "Commitments",
    menu_title9: "Video",
    menu_title10: "Documents",
    menu_title11: "Performance",
    menu_title12: "Images And Video",
    menu_title13: "Models",
    menu_title14: "Prices",
    menu_title15: "Customer Pricelists",
    menu_title16: "Markets",
    menu_title17: "portalCommitments",
  },
  pageTitle: {
    TravelList: "Travel List",
    Customer: " Customer",
    Order: "Order",
    OrderStatus: "Order Status",
    CustomerDet: "Customers Profile",
    CompetitiveProductAnalysis: "Competitive Analysis"
  },
  CustomerPage: {
    tips:'The current style already has the main image. Do you confirm the replacement?',
    price:" Selling price",
    priceSecond:"Fob Factory Price",
    prices:"Fob Approved Selling Price",
    MainImage:"Main Image",
    SkuClass:"Style type",
    Variation:"Variation",
    Sponge:"Filler",
    tabTitle1: " Sales Amount",
    tabTitle2: "Model Ranking",
    tabTitle3: "Surcharge",
    tabTitle4: "Line Up",
    tabTitle5: "Chargeback",
    OverdueAmount: "Overdue Amount",
    AccountReceivable: "Account Receivable",
    tb1: "Name",
    Cnumber: "Customer Code",
    Cname: "Account",
    Country: "Country/Area",
    City: "City",
    PoCode: "Postal Code",
    tel: "Phone",
    addr: "Address",
    InCompany: "Insurance Company",
    paymentTerm: "PAYMENT TERM",
    CreditLine: "Credit Line",
    wip: "WIP",
    AmountReceivable: "Account Receivable",
    TOT: "Terms Of Trade",
    STP: "Ship-To-Party",
    Confirm: "Confirm",
    Fabric: "Material",
    quty: "Estimated Containers",
    CType: "Customer Type",
    AddBusinessCard: "Business Card",
    Attachment: "Attachment",
    Remark: "Remark(Specs.)",
    AddCustomer: "Commitment Form",
    CustomerDet: {
      thTitle1: "Date",
      tnouo:"Unshipped Amount",
      thTitle2: "Current Month's Sales",
      thTitle3: "Same Period Last Year",
      thTitle4: "Monthly YOY Rate",
      thTitle5: "Expense Type",
      thTitle6: "Current Amount",
      thTitle7: "Sales Amount",
      thTitle8: "Model",
      thTitle9: "skuCode",
      thTitle10: "productCode",
      thTitle11: "SKU Code",
      thTitle12: "Model",
      thTitle13: "Arrangement",
      thTitle14: "Product Code",
      thTitle14s:"Item Code", //不要问我为什么同一个字段要 中文都一样，但是英语不一样，因为..
      thTitle15: "Terms Of Trade",
      thTitle16: "Material",
      thTitle17: "Color",
      thTitle18: "Current Price",
      thTitle19: "Sales amount of this year",
      thTitle20: "Sales amount of last year",
      thTitle21: "Year-over-Year%",
      thTitle22: "Picture",
      thTitle23: "Current Total Shipemt Amount",
      thTitle24: "Shipment In Sales Amount Rate",
      thTitle25: "Brand",
      thTitle26: "Expiration Date",
      thTitle27: "Sales Department",
      thTitle28:"Last Period's Total Shipment Amount",
      thTitle29: "YOY Comparison",
      thTitle30: "Current Total Shipemt Quantity",
      thTitle31: "Current Total Shipemt Quantity",
      thTitle32: "Shipment In Sales Quantity Rate",
      thTitle33: "Invoice Amount",
      thTitle34: "Invoice Qty",
      thTitle35: "First shipment date",
      thTitle36: "Customer Transaction Price",
      thTitle37: "FOB Price （Including Tariff)",
      thTitle38: "FOB Price",
      thTitle39: "Customer Transaction Price（Including Tariff)",
      thTitle40: "Total Amount of {t} Budget",
    },
    modelTye: "New Model to Customer",
    yes: "Yes",
    no: "No",
    saleDept: "Sales Department",
    LineUp: {
      blankets: 'Leather / Fabric',
      spec: 'Category',
      level: 'Level',
      model: 'Model',
      sku: 'SKU',
      coverCode: 'Cover Code',
      coverName: 'Cover Name',
      fobPrice: 'FOB Price (USD)',
      picture: 'Picture',
      floorDisplays: 'Floor Displays',
      budget: '{t} Year Budget',
      previousYearJanDec: '{t} Annual Sales Volume',
      salesYTD: '{t} SalesYTD',
      samePeriodSalesPreviousYear: '{t} Sales Volume in the Same Period',
      growthRate: 'Growth Rate',
      openOrders: 'Open orders (All status)',
      introductionDate: 'First Shippment Date',
      status: 'Status',
      year: 'Year',
      amount: 'Amount',
      addFloorSlot: 'Add Floor Slot'
    }
  },
  saleBudget:{
    tm:'Travel Expenses',
    tnr:'Total Net Revenue',
    tdr:'Total DiscountRate',
    month: "Month",
    Account:"Account",
    dr:'Discount rate',
    fsp:'FOB standard price',
    nbv:'Net business volume',
    fr:'Free replacement',
    oftf:'Ocean freight + trucking fee',
    ae:'Abnormal expenses',
    Tariff: "Tariff",
    bv:'Business volume',
    project:'project',
    bi:'BUYRER INFORMATION',
    qc:"Quality Control Contact",
    cfab:"Contact for Appointment Bookings",
    cfo:"Controller CFO Information",
    wm:"Warehouse Manager",
    osic:"On Site Inspection Contact",
    clci:"CUSTOMER LOGISTICS CONTACT INFORMATION",
    bn:"Bank Name",
    bac:"Beneficiary A/C#",
    Baddress:'ADDRESS',
    bbi:"BENEFICIARY'S BANK INFORMATION",
    bc:"Buyer contracts",
    mfs:"Main Furniture Suppliers",
    fti:"Federal Tax ID",
    cas:"Customer annual sales",
    nolp:"Name of legal peron",
    sta:'Ship to Address',
    dcn:'DBA Company Name',
    ci:"CUSTOMER BASIC INFORMATION",
    summary:"Summary",
    ysdrRate: "Budget Growth Ratio%",
    ysbr: "Year Budget Achieve Ratio%",
    cass:'Customer Approx Sofa Sales',
    crsim:'Customer Retail sales ',
    VPdiscountRate:"VP Discount Rate",
    salesBudget:"SalesBudget",
    vpSales:"VP/Sales",
    customerName:"Customer",
    customerCode:"Customer Code",
    customerType:"Customer Type",
    budgetYear:"Budget Year",
    budgetQuota:"Budget Quota",
    budgetLabel:"Budget",
    yoyGrowth:"Growth Ratio",
    monthMap:{
      '01':"Jan.",
      '02':"Feb.",
      '03':"Mar.",
      '04':"Apr.",
      '05':"May",
      '06':"Jun.",
      '07':"Jul.",
      '08':"Aug.",
      '09':"Sep.",
      '10':"Oct.",
      '11':"Nov.",
      '12':"Dec.",
    }
  },
  Customer: {
    CustomerManagement: "Customer Management",
    state: "State",
    LocalRanking: "Local Ranking",
    CustomerAnualSales: "Customer Anual Sales",
    ApproxFurnitureSales: "Approx Furniture Sales",
    ManWahSales: "ManWah Sales",
    TargetSales: "Target Sales",
    AddNewCustomerData: "Add New Customer Data",
    CustomerInformationion: "Customer Informationion",
    ViaitingTimeLately: "Visiting date",
    StoreNumber: "Store Qty",
    level: "Account class",
  },
  OrderPage: {
    tabTitle1: "All",
    tabTitle2: "PI Issued",
    tabTitle3: "PI Signed",
    tabTitle4: "Factory confirmed",
    tabTitle5: "Scheduled",
    tabTitle6: "Inventory",
    tabTitle7: "Shipped",

    Order: "Order",
    OrderDate: "Order Date",
    PONO: "PO NO",
    Destination: "Destination",
    PaymentTerms: "Payment Terms",
    payTerms: "Payment Terms",
    Period: "Initial Planned Finish Date",
    indexTb: {
      t1: "Customer Code",
      t2: "Customer Name",
      t3: "PI Issued",
      t4: "PI Signed",
      t5: "Factory confirmed",
      t6: "Scheduled",
      t7: "Inventory",
      t8: "Shipped",
      t9: "All",
    },
    thead: {
      title1: "Model",
      title2: "Desc.",
      title3: "Color",
      title4: "Quantity",
      title5: "Price",
    },
    orderlist: {
      th1: "Request Delivery Date",
      th2: "Order Receive Date",
      th3: "Planned Production Date",
      th4: "Model",
      th5: "Color",
      th6: "Brand",
      th7: "Expected Material ready date",
      th8: "Actual Material ready date ",
      th9: "Estimated Completion Date",
      th10: "ETD",
      th14: "ETA",
      th11: "Actual Completion Date",
      th12: "Container No.",
      th13: "POD Status",
      th15: "Invoice Number",
      th16: "Invoice Amount",
      th17: "Actual Completion Date",
    },
  },
  OrderAverageDeliveryTime: {
    shipped:'Shipped',
    unshipped: 'Unshipped',
    orderCreateTime: 'Order Create Time',
    orderOccupationTime: 'Order Occupancy Time',
    no: 'No.',
    vpSales: 'VP/Sales',
    customerName: 'Customer',
    cargoState: 'Cargo State',
    orderQuantity: 'Order Quantity',
    orderA2C: 'PI Issued → Signed',
    orderC2D: 'PI Signed → Confirmed',
    orderD2Completed: 'PI Confirmed → Finished',
    orderCompleted2Vanning: 'Finished → Loaded',
    orderCompleted2Delivery: 'Finished → Shipped',
    total: 'Lead Time  PI Issued → PI Shipped',
    exportFileName:'Customer Order Average Delivery Time'
  },
  reportItem: {
    Title: "Report",
    ItemTitle1: "Net Sales Revenue Analysis",
    ItemTitle2: "Overdue Account Receivables",
    ItemTitle3: "Order Input And Shipping Report",
    ItemTitle4: "Customer Container Tracking Report（Surcharge）",
    ItemTitle5: "Ready CTNS To Ship",
    ItemTitle6: "Export Sales Analysis Per Customer",
    ItemTitle7: "Export Sales Analysis Per Cover No",
    ItemTitle8: "Export Sales Analysis Per Model",
    ItemTitle9: "Sales Detail Report",
    ItemTitle10: "Service Order Status Report",
    ItemTitle11: "Statement Of Business Shipments And Revenues",
  },
  reportpage1: {
    Ccode: "Customer Code",
    VPname: "VP Name",
    Cname: "Customer Name",
    title1: "This month invoice amount",
    title2: "Invoice amount of the same period last year",
    title3: "Month Ratio Compare",
    title4: "Invoice amount Current year",
    title5: "Prior Year's invoice amount",
    title6: "Year Ratio Compare",
    NTitle1: "Arrangement",
    NTitle2: "Estimated Containers",
    NTitle3: "Confirmed Orders QTY",
    NTitle4: "Total Amount (USD)",
    NTitle5: "Confirmed Containers",
  },
  reportpage2: {
    days: "days",
    Ccode: "Customer Code",
    Cname: "Customer Name",
    title1: "Insurance Company",
    title2: "Terms of payment",
    title3: "Account Receivable",
    title4: "Overdue Amount",
    title5: "Last Payment Date",
    title6: "Last Payment Amount",
  },
  reportpage4: {
    Ccode: "Customer Code",
    Cname: "Customer Name",
    ChassisFee: "Chassis Fee",
    DropPickUpFee: "Drop & Pick Up Fee",
    PrePull: "Pre Pull",
    YardStorage: "Yard Storage",
    OverTimeWaiting: "Over Time Waiting",
    Demurrage: "Demurrage",
    ChassisSplit: "Chassis Split",
    CustomsExam: "CustomsExam",
    ECD: "Extra Charge for Delivery",
    Totalcost: "Total additional cost",
  },
  reportpage5: {
    amercement:"amercement",
    ordersWithoutSO: "Orders without SO",
    ordersWithSO:"Orders with SO",
    totalOrders:"Total Orders",
    finishedGoodsInventoryInformationReport: 'SO Status',
    finishedGoodsInventoryAgeReport: 'Finished Goods Inventory Age Report',
    ECDDTR:"Production and Shipping Performance Analysis",
    orderWithSO: 'Order with SO',
    orderWithoutSO: 'Order without SO',
    inventory: 'Inventory',
    dept: 'Division',
    customerName: 'Customer',
    tradeTerms: 'Trade Terms',
    tradeTerms2: '2/Trade Terms',
    lessThan15days: 'Less than 15 days',
    between15and30days: '16-30 days',
    between30and60days: '31-60 days',
    between60and90days: '61-90 days',
    between90and120days: '91-120 days',
    between120and150days: '121-150 days',
    between150and180days: '151-180 days',
    over180days: 'Over 180 days',
    day: 'days',
    stockDays: 'Stock Days',
    stockDaysScope:'Stock Days Range',
    PI: 'PI#',
    customerPO: 'Customer PO#',
    model: 'Model',
    spec: 'Spec.',
    material: 'Material',
    color: 'Color',
    fob: 'FOB',
    qty: 'Order QTY',
    finishedDay: 'Finished Day',
    hasSolution: 'Solution Available YES/NO ',
    solution: 'Solution',
    viewScope: 'View Scope',
    more60Days: 'Over 60 days',
    vbeln: 'PI#',
    openingDate: 'CY Open Date',
    zjsi: 'SI Closing Date',
    closingDate: 'CY Closing Date',
    etd: 'ETD',
    unit: 'Unit：CTNS',
    vpAssistance: 'VP Assistant',
    csr: 'CSR',
    customerCode: 'Customer Code',
    incoterms: 'Trade Term',
    orderAmount: 'Order Amount',
    actuallyFinishedDate: 'Actual Completion Date',
    so: 'SO#',
    eta: 'ETA',
    soStatus: 'SO Status',
    soTrue:"Have SO",
    soFalse:"NO SO",
  },
  reportpage8_7: {
    title0: "Cover Number",
    title1: "Model Number",
    title2: "This Month Amount",
    title3: "This Month Ratio",
    title4: "Prior Year Month Amount",
    title5: "Current Year Ratio",
    title6: "Month Ratio Compare",
    title7: "Current Year Amount",
    title8: "Prior Year Amount",
    title9: "Year Ratio Compare",
    Country: "Country/Area",
    code: "Code",
    name: "Name",
    dept: "Dept.",
    ctn: "CTN in warehouse(40HQ)",
    Cname: "Customer Name",
    TradeTerms1: "1/Trade Terms",
    TradeTerms2: "2/Trade Terms",
  },
  reportpage9: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    tips5:"The cubes of the container must be within the range of 2,000 ft³ to 2,350 ft³",
    tips6:"The cubes of the container must be within the range of 56.63 m³ to 66.54 m³",
    tips7:"The order includes multiple colors for the same model, please check",
    tips8:"Cannot send",
    search: {
      title1: "Department",
      title2: "Order Recived Date ",
      title3: "Factory",
      title4: "Invoicing Date",
      title5: "Cover",
    },
    thTitle: {
      title1: "Customer Code",
      title2: "Name",
      title3: "VP",
      title4: "Sales",
      title5: "Sales Dept",
      title6: "Brand",
    },
  },
  reportpage10: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    search: {
      title1: "Department",
      title2: "VP/Sales",
      title3: "Company",
      title4: "Date",
    },
    thTitle: {
      title1: "No",
      title2: "Division",
      title3: "VP/Sales",
      title4: "Customer",
      title5: "Travel date",
      title6: "Market",
      title7: "Container Commitment",
      title8: "Container Confirm",
      title9: "Last Month Intake CTN",
      title10: "Last Month Intake Volume($)",
      title11: "Same Month Last Year Intake CTN",
      title12: "Same Month Last Year Intake Volume(＄)",
      title13: "YOY Growth Last Month In Volume(%)",
      title14: "This Month Intake CTN",
      title15: "This Month Intake Volume($)",
      title16: "Order intake in this year CNT",
      title17: "Order intake in this year $",
      title18: "YOY Growth This Month In Volume(%)",
      title19: "This Year Total Intake CTN",
      title20: "This Year Total Intake Volume ($)",
      title21: "Last Year Total Intake CTN",
      title22: "Last Year Total Intake Volume ($)",
      title23: "YOY Growth In Total Intake Volume(%)",
    },
  },
  reportpage11: {
    tips1: "The start date of receipt cannot be later than the end date",
    tips2: "Invoicing start date cannot be later than end date",
    tips3: "Only data within half a year can be exported after receiving orders",
    tips4: "Invoicing can only export data within half a year",
    search: {
      title1: "Department",
      title2: "VP/Sales",
      title3: "Customer",
      title4: "Date",
    },
    thTitle: {
      title1: "No",
      title2: "Division",
      title3: "VP/Sales",
      title4: "Customer",
      title5: "shipped ctn qtys last month",
      title6: "amount",
      title7: "discount",
      title8: "commission/salary",
      title9: "shiped ctn qty this month",
      title10: "amount",
      title11: "shiped ctn qty next month",
      title12: "amount",
    },
  },
  report20: {
    CRL:"Customer Ranking List",
    fobPrice:"FobPrice",
    classification: "Level",
    leather: "Leather",
    Fabric: "Fabric",
    mwSlot: "MW Slot",
    floorSlot: "Floor Slot",
    picture: "Picture",
    rank: "No.",
    FOBPrice: "Price",
    LandedPrice: "Landed Price",
    RetailPrice: "Retail Price",
    total: 'Total',
    suppliers: 'Supplier',
    storeNumber: 'Store QTY',
  },
  Competing: {
    tabTitle1: "Title",
    tabTitle2: "Price",
    tabTitle3: "Competitive Information",
    formlable0: "Title",
    formlable1: "Amount",
    formlable2: "Details",
    formlable3: "Describe",
    formlable4: "User",
    formlable5: "Date",
    formlable6: "Country/Area",
  },
  competingGoodsInfo: {
    title1: "SKU",
    title2: "Description",
    title3: "Cubes",
    title4: "Length",
    title5: "Depth",
    title6: "Price",
    title7: "Total Price",
    Commitments: "Commitments",
  },
  formlabel: {
    exportExcel2:"Including All Images",
    exportExcel1:"Only Main Image",
    exportExcel: "ExportExcel",
    exportPdf: "ExportPdf",
    label1: "Customer invitation information report",
    label2: "Customer invitation information update template",
    label3:'Split Sheet',
    label4:'Merge Export',
    label5:'Delivery Schedule Details',
    label6:'PI Approval Detail Report',
    label7:'Inventory Overdue Days Report',
    label8:'Export Division Finished Goods Inventory Age Analysis',
    download:'Download and upload the template',
    createdDate:"Created Date",
    updateDate:"Update Date",
    Month: "Month",
    Quarter: "Quarter",
    Year: "Year",
    ResetBtn: "Reset",
    SearchBtn: "Search",
    SingleBtn1: "Order Intake",
    SingleCount:"Total Order Intake",
    SingleBtn2: "Order Shipped",
    SingleCounts:"Total Shipped",
    ReturnBtn: "Return",
    addBtn: "Add",
    submitBtn: "Submit",
    editBtn: "Edit",
    Department: "Department",
    downloadbtn: "Download",
    downloadTemplate: "Download Template",
    upload: "Upload",
    cancel: "Cancel",
    Selectfile: "Select file",
    classify: "Classify",
    title: "Title",
    delete: "Delete",
    handle: "Edit",
    keyword: "Keyword",
    createCommitment: "Create Commitment",
    import: "Import",
    export: "Export",
    exportData: "ExportData",
    exportDatas:"Export Commitments List",
    exportType: "Customer Invitation Process Schedule",
    exportDataThree:'Export Order Status',
    exportDataSecond: "Export Intention Order",
    exportDataAll:"Export Commitments Catagory Details",
    exportDataAllT:"Export Order Status Details",
    exportCountSheet:"Export order summary",
    Count:"Count",
    partExport: 'Part Export',
    allExport: 'All Export'
  },
  Performance: {
    tabTitle0: "Customer ",
    tabTitle1: " Budget",
    tabTitle2: " Acutal",
    tabTitle3: " Acutal",
    tabTitle4: " Actual/Budget Ratio ",
    tabTitle5: " Growth Ratio",
    tabTitle6: " Budget ",
    tabTitle7: " Acutal ",
    tabTitle8: " Acutal ",
    tabTitle9: " Actual/Budget Ration ",
    tabTitle10: " Growth Ratio",
    tabTitle11: " Actual ",
    Division1: " Total",
    Division2: " Division Two",
    Division3: " Division Three",
    cabinet: "Ctn Qty",
    Budget: "Budget 2024 Jan-Dec",
    Acutal1: "Acutal 2023",
    Acutal2: "Acutal 2019",
    vpassistant: "VP Assistant",
    ESAPC: "Export Sales Analysis Per Customer",
    BIT: "Budget Import Template",
  },
  Documents: {
    uptime: "Upload date",
    filetitle: "Document title",
    usDp:'US Department Documents'
  },
  timeOptions: {
    today: "today",
    oneMonthAgo: "a month ago",
    threeMonthAgo: "three months ago",
    sixMonthAgo: "six months ago",
    startPlaceholder: "Start Date",
    endPlaceholder: "End Date",
  },
  TravelList: {
    byway: "Others",
  },
  ModelsDet: {
    title: "Pricing And Images",
  },
  Hello: "Sell More",
  PleaseEnter: "Please Enter",
  PleaseSelect: "Please select",
  Brand: "Brand",
  DepPleaseSelectBrand: " Brand",
  DepPleaseSelectFactory: "Factory",
  psdiv:"Please Select Division",
  StartDate: "Start Date",
  EndDate: "End Date",
  Date: "Date",
  MonthRange: "ETD Date",
  types: "types",
  PleaseSelectType: "Please select type",
  modifyPassword: "modify password",
  oldPassword: "old password",
  newPassword: "new password",
  confirmPassword: "confirm password",
  confirm: "Confirm",
  logout: "Logout",
  firstLogin: "First login or password is too simple",
  PleaseEnterNewPassword: "Please enter a new password",
  passwordRequirements: "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one digit",
  PleaseConfirmPassword: "Please enter it again",
  confirmError: "Passwords do not match",
  passwordNoChange: "New password cannot be the same as the old password",
  logoutConfirm: "Logout of the current account? The opened tabs and user settings will be saved.",
  order: {
    Division : "Division",
    Market: "Market",
    PleaseEnterTheSearchKeyword: "Please enter the search keyword",
  },
  newPriceList:{
    Comments:"Comments",
    Created:"Created",
    Updated:"Updated",
    Link:"Link",
    Rep:"Rep",
    entries:"entries",
    typeToFilter:"type to filter",
    pricelistForm:"Pricelist Form",
    createdPricelist:"Created Pricelist",
    columns1:"Vietnam Canada",
    columns2:"CFR",
    columns3:"FOB",
    title1:'Terms',
    columns4:"Photo"
  },
  prices: {
    quoteRequired:"quoteRequired",
    quoteLabel: "Quote",
    newPriceList:"new PriceList",
    priceLists:"priceLists",
    radio1:"Product information",
    radio2:"Manual addition",
    radio3:"SAP",
    titleInfo:"SourceType",
    errorTip:'The combination name and function are required',
    errorTips:"The selected prices are duplicated and cannot be added",
    priceStart:"priceStart",
    priceEnd:"priceEnd",
    Function: "Function",
    PieceCount: "Piece Count",
    CoverGrade: "Cover Grade",
    CoverType: "Cover Type",
    MotionType: "Motion Type",
    category: "category",
    MaterialInfo:"Cover Grade",
     MaterialClass: "Cover Type",
    PowerClass:"Motion Type",
    style:"Search by Model" ,
    factory:"choose factory",
    search:"Search",
    description:"Description",
    Cubes:"Cubs(cuft)",
    Cube:"Cubs(m³)",
    length:"Length(in)",
    Depth:"Depth(in)",
    height:"Height(in)",
    lengths:"Length(cm)",
    Depths:"Depth(cm)",
    heights:"Height(cm)",
    vietnamP:"Vietnam/FOB",
    cnP:"China/FOB",
    Type:"Type",
    Edit:"Edit",
    change:"Edit",
    sceneGraph:"Lifestyle",
    rawPic:"Images",
    priceTickets:"Catalog",
    back:"View Arrangements",
    clickPreview:"Click on the Cover Grades to show all the prices",
    pricesImportTemplate:"Prices Import Template",
    exportPriceSheet:"Generate Quote Sheet",
    addPriceSheet:"Add Quote Sheet",
    priceSheetFileName:"FileName for Quotesheet",
    priceSheetColorNum:"Select COlor Number for Quotesheet",
    selectPic:"Select a photo for Quotesheet",
    noPic:"No images available",
    quoteSheet:"Quote Sheet",
    chooseCover:"Available Covers",
    priceSheetName:"PriceSheetName",
    addNewPriceSheet:"AddNewPriceSheet",
    multipleSelection:"MultipleSelection",
    specificationNum:'SpecificationNum',
    view:"View",
    allPrice:"All Prices",
    addToPriceSheet:'Add To PriceSheet'
  },
  Report: {
    PleaseEnterCodeOrName: "Please enter code or name",
    PleaseEnterNameSearch: "Please Enter Name Search",
    AllTypes: "All Types",
  },
  /*此处上边翻译已进行核对，此处之后进行编写*/
  loading: "loading",
  noMore: "noMore",
  ALLTYPES: "ALL TYPES",
  model: "Model",
  Temporarily: "Temporarily no data",
  menu: {
    menu_title15: "Markets List",
    menu_title16: "Commitments List",
    menu_title17: "Summary by Customer",
    menu_title18: "Summary by Model",
  },
  Commitments: {
    exportMes:'Export Product Information',
    area:'Area',
    footerTips:"No more data",
    id: "ID",
    NewModelLaunchDate: "New Model Launch Date",
    MarketsStartDate: "Markets Start Date",
    MarketsEndDate: "Markets End Date",
    NewModelOrigin: "New Model Origin",
    OldModelReExhibit: "Old Model Re-Exhibit",
    OrderCutofftime: "Order Cutoff Date",
    ShippingCutoffTime: "Shipping Cutoff Date",
    Maintainer: "Maintainer",
    MaintenanceDate: "Maintenance Date",
    MaterialNumber: "Material Number",
    DescCombination: "Categories",
    MaintainTemplate: "New Model Maintain Template",
    ArrangementMaintainTemplate: "Arrangement Maintain template",
    ExhibitionBonusDistributionTemplate: "Exhibition Bonus Distribution Template",
    ExhibitionBonusStylesTemplate: "Exhibition Bonus Styles Template",
    MarketNameCN: "Market Name-CN",
    MarketNameEN: "Market Name-EN",
    SalesDepartment: "Sales Department",
    OrderPlaceDate: "Order Place Date",
    CustomerConfirmedDate: "Customer Confirmed Date",
    VPSales: "VP/Sales",
    CommitmentQTY: "Commitment QTY(ctn)",
    ConfirmedOrderQTY: "Confirmed Order QTY(ctn)",
    ConfirmedOrderAMT: "Confirmed Order AMT(USD)",
    PODate: "PO Date",
    RequestedReadyDate: "Requested Ready Date",
    ReasonForNotOrdering: "Reason For Not Ordering",
    BonusMonth: "Bonus Month",
    Nationality: "Nationality",
    OverdueDays: "Overdue Days",
    MaterialCode: "Material Code",
    StyleSpecifications: "Model-Desc.",
    POOrderNumber: "PO#",
    LineItemNumber: "Line Item Number",
    Title: "Position",
    Describe: "Describe",
    StartDate: "Start Date",
    endDate: "End Date",
    Country: "Country/Area",
    companyName:'Company Name',
    CommitmentsList: "Commitments list",
    AddMarket: "Add Markets",
    MarketsList: "Markets List",
    Market: "Market",
    MarketsName: "Market Name",
    NewCustomer: "New Customer",
    CustomerName: "Customer Name",
    selectCustomerName: "Please select Customer Name",
    selectCountry: "Please select Country/Area",
    saleDeptInp: "Please Input Sales Department",
    Sales: "Sales",
    Covers: "Covers",
    Confirm: "Confirm",
    Edit: "Edit",
    Arrangements: "Arrangements",
    CustomerType: "Customer Type",
    NumberOfOrders: "QTY(pcs)",
    OrderAmount: "Order AMT(USD)",
    TotalAmount: "Total Amount",
    Color: "Color",
    quantity: "QTY",
    IMIC: "Invitation Market Customers Information",
    IMICT: "Invitation Market Customers Information Template",
    AnnualTurnover: "Annual Turnover",
    ViaitingTimeLately: "Last Customer Visit Date",
    Company: "Customer Name",
    Customer: "Customer Representitive",
    StoreNumber: "Store Qty",
    MarketTime: "Appointment Time",
    NewReGularCustomer: "New/Regular Customer",
    Email: "Email/Tel",
    Division: "Division",
    AddExReservation: "Add ExReservation",
    create: "Create",
    CommitmentConfirm: "Commitment Confirm",
    vpSalesExport: "VP/Sales Export",
    officeExport: "Office Export",
    expectedFactoryDate: 'Plan Factory Visit Date',
    actualFactoryDate: 'Actual Factory Visit Date',
    whetherAttendParty: 'Attend MW Party',
    partyAttendanceNum: 'Party Attendance',
    sofaSales: 'Approximate Furniture Business Sales',
    mwSales: 'ManWah Sales',
    percentage: 'MW Percentage',
    mUnit: '(in millions)',
    marketRanking: 'Market Ranking',
    countryState: 'Country/Area',
    countryStates:'Customer Country/Region',
    nationalitys:"VP/Sales Nationality",
    state: 'State',
    viewExhibitionCalendar: 'View Market Calendar',
    exhibitionCalendar: 'Market Calendar',
    appointmentList: 'Appointment List',
    approvalList: 'Approval List',
    submitForApproval: 'Submit For Approval',
    status: 'Status',
    approvalStatus: 'Approval Status',
    pendingSubmission: 'pending Submission',
    pendingReview: 'Pending Review',
    pendingApproval: 'Pending Approval',
    approved: 'Approved',
    rejected:'Rejected',
    recall: 'Recall',
    clientsToInvite: 'Clients To Invite',
    approverComments:"Approver's Comments",
    generalManagerApproval:"General Manager's Approval",
    view: 'View',
    approval: 'Approval',
    exhibitionDepartment: 'Exhibition Department',
    appointmentApprovalProcess: 'Appointment Approval Process',
    CustomersToInvite: 'Customers To Invite',
    RegularCustomers: 'Regular Customers',
    NewCustomers: 'New Customers',
    detail: 'Detail',
    agree:'Agree',
    reject:'Return to Previous Level',
    reject1:'Return to Business Unit',
    reviewComments:'Review Comments',
    approvalComments:'Approval Comments',
    nextClientVisitDate: 'Next Client VisitDate',
    meetingContent: 'Meeting Content',
    remark: 'Note',
    toBeInvited: 'To Be Invited',
    hasBeenInvited: 'Has Been Invited',
    retailer: 'Retailer',
    wholesaler: 'Wholesaler',
    online: 'Online',
    updateDate: 'Update Date',
    addAppointment: 'Add Appointment',
    actualVisitMarketTime: 'Actual Visit Market Time',
    marketArrivialConfirm: 'Market Arrivial Confirm'
  },
  no:'No.',
  Tips: "Tips",
  PleaseSelectTheDownloadMethod: "Please select the download method!?",
  Download: "Download",
  CopyLinks: "Copy Links",
  Receivables: "Overdue Account Receivables",
  OrderInput: "Order Input Summary",
  OrderInputDetailList: "Order Input Detail List",
  Firstlevelreport: "First level report",
  Secondaryreport: "Secondary report",
  VisitTime: "Visit Time",
  addTravel: {
    CustomerName: "Please Input Customer Name",
    PleaseInputContacts: "Please Input Contacts",
    CustomerLocation: "Please Input Customer Location",
    CustomerDetailsP: "Please Input Customer DetailsP",
    Opportunity: "Please Input Opportunity",
  },
  addCompetitors: {
    PleaseInputTitle: "Please Input Title",
    PleaseInputAmount: "Please Input Amount",
    PleaseInputDetails: "Please Input Details",
    PleaseInputCustomerDescribe: "Please Input Customer Describe",
    PleaseInputUserName: "Please Input User Name",
    selectdate: "select date",
  },
  AmountIsNotANumber: "Amount is Not a number or",
  CountryNotselected: "Country Not selected or",
  FileIsNull: "file is null",
  UploadPicturesCaninJPGformat: "Upload pictures can only be in JPG format!",
  addSuccess: "add success",
  PleaseInputcovers: "Please Input covers",
  editPricelist: "editPricelist",
  PleaseSelectModel: "Please select model",
  factory: "Factory",
  PleaseSelectArrangements: "Please select arrangements",
  PleaseInputSku: "Please Input sku",
  PleaseInputDescription: "Please Input description",
  PleaseInputCubes: "Please Input cubes",
  PleaseInputLength: "Please Input length",
  PleaseInputDepth: "Please Input depth",
  PleaseInputPrice: "Please Input price",
  AddVideo: "Add Images&Video",
  EditVideo: "Edit Images&Video",
  AddCover: "Add Covers",
  EditCover: "Edit Cover",
  PleaseInputColor: "Please Input Color",
  PleaseInputTitle: "Please Input Title",
  uploadDocuments: "upload Documents",
  Normal: "Normal",
  LifeStyle: "Lifestyle Photo",
  Closeup: "Closeup",
  Videos: "Videos",
  CatalogPages: "Catalog Pages",
  ConfirmOperation: "Confirm Operation",
  Downloads: "Downloads",
  AddtoEmaiddl: "Add to Email",
  Small: "Small",
  Medium: "Medium",
  Large: "Large",
  HiRes: "HiRes",
  SendContentViaEmail: "Send Content Via Email",
  ToSendToMultipleEmails: "To send to multiple emails,please add a com between addresses",
  AddData: "add Data",
  ClientName: " Client Name",
  PleaseInputBudge: "Please Input Budge",
  PleaseInput: "Please Input",
  BatchImport: "Batch import",
  SelectFile: "Select file",
  level: "Level",
  ImagesAndVideo: {
    EmailTo: "Email To",
    Subject: "Subject",
    Body: "Body",
    SendEmail: "Send Email",
    Clear: "Clear",
    remove: "remove",
    type: "Type",
  },
  price: {
    modifyFunctionName:"Modify Function Name",
    modifyTheCombinationName:"Modify the combination name",
    addtoTheOriginalCombination:"Add to the Original Combination",
    createNewCombination:"Create a New Combination",
    combinationName:"combinationName",
    TypeToFilter: "Type to filter",
    Current: "Brand",
    NewModel: "New Model",
    table: {
      Image: "Image",
      Model: "Model",
      Brand: "Brand",
      Current: "Current",
      Arms: "Arms",
      Backs: "Backs",
      Seats: "Seats",
      Mechanisms: "Mechanisms",
      Features: "Features",
      Styles: "Styles",
      Collections: "Collections",
      Categories: "Categories",
      Remarks: "Remarks",
      handle: "Handle",
    },
    From: {
      ModelForm: "Model Form",
      Name: "Name",
      Remarks: "Remarks",
      Style: "Style features",
      Construction: "Construction",
      CountryOfOrigin: "Country of origin",
      Unique: "Unique",
      Arms: "Arms",
      CreateModel: "Create Model",
      Close: "Close",
    },
  },
  ShippedOrderSummary: "Shipped Order Summary",
  ShippedDetailList: "Shipped Detail List",
  util: {
    CopySuccess: "Copy success",
    ImageAddedtoEmail: "Image added to email",
    ImageAlreadyInEmail: "Image already in email",
  },
  resetPassword: {
    username: "username",
    pleaseEnterUsername: "Please enter username",
    reset: "Reset",
    resetSuccess: "Reset success",
    confirmReset: "Confirm reset password?",
    tip: "Tip",
  },
  covers: {
    coverName: "Cover Name",
    coverNumber: "Cover Code",
    coverGroup: "Cover Group",
    coverType: "Cover Type",
  },
  modelStatus: {
    running: "Running",
    newModel: "New Model",
    newCover: "New Cover",
    phasedOut: "Phase Out",
    dropped: "Dropped",
  },
  Admin: {
    bd: "Affiliation Business Division",
    role: "Role",
    account: "Account",
    NOL:"Number of Logins",
    TL:"Total Accounts",
    AP:"Active Ratio",
    confirmInheritanceMessage:"Are you sure about the inheritance? Once confirmed, the change cannot be undone.",
    mes1:"(Note: The successor will inherit the departing person's exhibition customer information, competitor information, hierarchical relationships, etc., and once the data is operated, it cannot be undone.)",
    relevantP:'Relevant Personnel',
    addRelationship:"New relationship between resignation and inheritance",
    ot:"Operation Time",
    op:"Operator",
    inheritor:"Successor",
    fp:"Resigned Employee",
    rai:"Resignation Succession ",
    ariA:"Data inheritance for staff who have resigned",
    unit:"Unit",
    index: "No.",
    name: "Name",
    code: "Code",
    weight: "Weight",
    width: "Width",
    height: "Height",
    isUsed: "Is Used",
    skuType: "SKU Type",
    seats: "Seats",
    description: "Description",
    arrangementType: "Arrangement Type",
    motion: "Motion",
    motionType: "Motion Type",
    pieceCount: "Piece Count",
    uniqueArrangment: "Unique Arrangement",
    group: "Group",
    type: "Type",
    status: "Status",
    component: "Component",
    skin: "Skin",
    add: "Add",
    edit: "Edit",
    save: "Save",
    yes: "Yes",
    no: "No",
    update:'Update',
    copy: "Copy",
    active: "Active",
    inactive: "Inactive",
    pleaseEnter: "Please enter",
    pleaseSelect: "Please select",
    deleteInfo: "This operation will permanently delete the file. Do you want to continue?",
    promptInfo:"The cubes have achieved to 2200 square feets",
    errorInfo:"Fail to delete",
    confirm: "Confirm",
    cancel: "Cancel",
    tips: "Tips",
    sentence:"Inconsistent and cannot be created",
    networkError: "Network error",
    grade: "Grade",
    color: "Color",
    arms: "Arm",
    mechanisms: "Functional Mech",
    backs: "Back Cushion",
    features: "Product Feature",
    seats2: "Seat Cushion",
    styles: "Styles",
    provenance: "Provenance",
    china: "China",
    vietnam: "Vietnam",
    chinavietnam: "China or Vietnam",
    mexico: "Mexico",
    image: "Image",
    models: "Model",
    loadability: "Loading Ability",
    leather: "Leather",
    content: "Content",
    categories: "Categories",
    priceRange: "Price Range",
    cubes: "Cubes",
    coverGrade: "Cover Grade",
    length: "Length",
    depth: "Depth",
    price: "Price",
    selectiveColor: "Available Color",
    spec: "Spec.",
    cube: "Cube",
    lwh: "Product Size L*W*H (in)",
    packageSize: "Packaged Size L*W*H (in)",
    packageMethod: "Package Method",
    addOnOption: "Add-on Option",
    addOnOption1: "Add To Purchase List",
    salesPrice: "Sales Price",
    amountSum: "Amount SUM",
    cubeSum: "Cube SUM",
    customized: "Customization",
    pleaseEnterQTY: "Please Enter Quantity",
    containerCaculation: "Container Caculation",
    settlementPO: "Create PO",
    settlementPOTips: 'PO Caculation',
    continue:'Continue',
    container: 'Container',
    totalCargoVolume:'Total Cargo Volume',
    quantityOfGoods: 'Quantity Of Goods',
    containerVolumeUtilizationRate:'Container Volume Utilization Rate',
    POSettlement: "Create PO",
    addtoPo: "Add to PO",
    poNo: "PO No.",
    fax: "Fax",
    buyer: "Buyer",
    email: "Email",
    emailEnter: "Separated by semicolons for multiple email addresses.",
    freight: "Freight",
    cabinetType: "Cabinet Type",
    POType: "PO Type",
    category: "Category",
    leading: "Leading",
    marketNewModel: "Market New Model",
    discountAmount: "Discount Amount",
    ManufacturingPlant: "Manufacturing Plant",
    totalOrderAmount: "Total Order Amount",
    package: "Package",
    authorizedSignature: "Authorized Signature",
    signatureVerification: "Signature Verification",
    settingUp: "Create",
    closing: "Closing",
    closeOther: "Close Others",
    closeAll: "Close All",
    emailStatus: "Email Status",
    checkAll: "Check All",
    SAPStatus: "SAP Status",
    sentSuccessfully: "Sent Successfully",
    sent: 'Has Been Sent',
    failToSend: "Fail To Send",
    PONo: "PO No.",
    SAPPI: "SAP PI",
    subtotal: "Subtotal",
    sendPo:"Copy PO",
    sendToSap: "Send To SAP",
    sendEmail: "Send Email",
    exportPO: "Export PO",
    discountRate: "Discount Rate",
    salesDiscount: "Sales Discount",
    clear: "Clear",
    notSigned: "You haven't signed yet, are you sure to submit?",
    amountTotal: "Amount SUM",
    cubeTotal: "Cube SUM",
    pleaseSelectPO: "Please first check the data to be operated on",
    pts:"Attention please ！You can only choose one PO to copy!",
    pleaseSelectAvaliablePO: "All selected data must be valid",
    confirmDelete: "Confirm Delete?",
    offShelf: "Off Shelf",
    effective: "Effective",
    view: "Preview",
    userCode: "User Code",
    AllocateAmount: "Allocate Amount",
    position: "Position",
    readyDate: "Customer Request Delivery Date",
    marketModel: "Market Model",
    trait: "Feature",
    all: "All",
    material: "Material",
    qsInventoryAddCarError: 'There is no list of styles that can be ordered. Please contact the administrator to update it.',
    completeSetNumber: 'Complete Set Number',
    setQuantity: 'Set Quantity',
    total: 'Total',
    cis:'Can Be Send To SAP (YES/NO)',
    OTF:"ArchitectureBelongs",
    role:"Role",
    OFTHEDIV:"Business Unit",
    ArchitectureArea:"ArchitectureArea",
    BWC:"WeChatID",
    nationality: "Nationality",
    userAccount:"UserAccount",
    addAccount:"AddAccount",
    editAccount:"EditAccount",
    enable: "Enable",
    disable: "Disable",
    loginlog:"LoginLog"
  },
  travel: {
    title: "Travel",
    year: "Year",
    month: "Month",
    visitCustomer: "Visit Customer",
    exportReport: "Export Report",
    travelName: "VP/SALES Name",
    visitTime: "Visit Time",
    visitMode: "Visit Mode",
    country: "Country/Area",
    state: "Region",
    fullAddress: "Full Address",
    customerDetail: "Customer Detail",
    storeNum: "Store QTY",
    storeStyle: "Model QTY",
    mwStyle: "MW Model Num.",
    visitResult: "Visit Result",
    img: "Travel Image",
    businessCard: "Business Card",
    customerType: "Customer Type",
    new: "New Customer",
    old: "Regular Customer",
    customerName: "Customer Name",
    tel: "Tel",
    face: "In Person",
    shop: "Store Visit",
    other: "Other",
    followUp: "Pending Follow Up",
    competitors: "Competitors",
    company: "Competitors",
    placementNum: "Competitors Model QTY",
    competitorStyle: "Competitors Model Name",
    remark: "Remark",
    date: "Date",
    notBeEmpty: "cannot be empty",
    orders: "orders",
    shipping: "shipping",
    payment: "payment",
    quality: "quality",
    retailPrice: "Retail Price",
    TravelSchedule: "Travel Schedule",
    tips: "Please select at least one VP/Sales!",
    tips1: "Please select only one VP/Sales!",
    submitForApproval: 'Submit For Approval',
    approvalDataExists: 'Approval Data Exists',
    vpAssistant: 'VP Assistant',
    approvalStatus: 'Approval Status',
    pendingSubmission: 'pending Submission',
    pendingReview: 'Pending Review',
    pendingApproval: 'Pending Approval',
    approved: 'Approved',
    approvalList: 'Approval List',
    approval: 'Approval',
    travelPlan: 'Travel Plan',
    approvalProcessPlanning: 'Approval Process Planning',
    scheduledStartTime: 'Scheduled Start Time',
    scheduledEndTime: 'Scheduled End Time',
    travelVPSales: 'Travel VP/Sales',
    travelVPAssistant:'Travel VP Assistant',
    location: 'Location',
    detail: 'Detail',
    prospectVisitTargets: "Prospect Visit Targets",
    agree:'Agree',
    reject:'Return to Previous Level',
    recall: 'Recall',
    view: 'View',
    reject1:'Return to Business Unit',
    rejected:'Rejected',
    reviewComments:'Review Comments',
    approvalComments:'Approval Comments',
    approverComments:"Approver's Comments",
    generalManagerApproval:"General Manager's Approval",
    viewCompetitor: 'View Competitor',
    visitResults: 'Visit Results'
  },
  InventoryPlatform: {
    SRL:"SO Receiving-Loading",
    eta:"ETA",
    etd:"ETD",
    SRD:"SO Receiving Date",
    LoadingDate:"Loading Date",
    DeliverNo: "Delivery Order Number",
    OAR:"Order Adjust Reason",
    changeDays:"Order Adjust Days",
    PAFC:"Factory Confirm Days (Pl Approved-Factory Confirm)",
    FCD:"Factory Confirmed Date  (Original)",
    PCFT:"Purchase Confirm",
    PAD:"PI Approved Date",
    PCD:"Purchase Confirm Days (PI Approved-Purchase Confirm)",
    PD:"PO Date",
    adtips:'Delay Days',
    ADOL:"Delay Days (Promise-ETD/ETA)",
    ASD:"Shipment Days (Actual Finish -ETD)",
    APD:"Production Days (PI Approved-Actual Finish)",
    APAD:"PI Approved Days (PO Date-PI Approved)",
    ALT:"Lead Time (PO Date-ETD)",
    TAPOS:"Average Lead Time",
    seq: "Seq",
    customer: "Customer",
    customerCode: "Customer Code",
    customerName: "Customer Name",
    customerSKU: "Customer SKU#",
    mwSKU: "MW SKU#",
    model: "Model",
    color: "Color",
    item: "Spec.",
    fabricNumber: "Cover Code",
    numberOfStore: "Store QTY",
    storeFloorSampleQTY: "Store Floor Sample QTY",
    status: "Status",
    createUser: "Create User",
    createTime: "Create Time",
    operate: "Operate",
    enable: "Active",
    disable: "Inactive",
    remark: "Remark",
    save: "Save",
    saveSuccess: "Save successful",
    pleaseSelectData: "Please select data",
    CustomerInventoryInfoTpl: "Customer Inventory Information Template",
    ImportSuccessful: "Upload Successful",
    ProductInfo: "Product Information",
    ProductInfoTpl: "Product Information Template",
    customerDataTpl: "Customer Data Template",
    WeekStartTime: "Week Start Time",
    startMonth: "Start Month",
    endMonth: "End Month",
    CCD:'Competitor Created Date ',
    WeekEndTime: "Week End Time",
    ThisWeekInvoice: "Sold QTY",
    undeliveriedQTY: "Undeliveried QTY",
    CustomerInventory: "Actual Stock QTY",
    ProductInTransit: "In Transit",
    ProductInStock: "Product Stock QTY",
    ReplenishmentQTY:"Backup Order QTY",
    ReadyDate:"Ready Date",
    InProduction: "In Production",
    UnProduced: "Un-produced",
    MeterialAvailableStock: "Material Available Stock",
    MeterialInTransit: "Material In Transit",
    OrderQuantity: "Order Quantity",
    ShippedQuantity: "Shipped Quantity",
    ETD: "ETD",
    ETA: "ETA",
    Container: "Container#",
    StockQTY: "Available Stock QTY",
    StockQTYs: "Stock QTY ",
    IHOQ:"In Hand Order Qty",
    RequestReadyDate: "Request Ready Date",
    EstReadyDate: "Est. Ready Date",
    ActualReadyDate: "Actual Ready Date",
    deleteConfirm: "Do you want to delete the selected record?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    deleteSuccessful: "Delete successful",
    supplier: "Supplier",
    shipTo: "Ship To",
    customerPo:"Customer Po",
    po: "PO",
    PO:"PO#",
    weekDate: "Week Date",
    uploadTip1: "The file size cannot exceed 5M",
    uploadTip2: "The number of document lines cannot exceed 100 million",
    IncorrectDownload: "Incorrect Download",
    file: "File",
    basicInfo: "Basic Info",
    categoryId: 'Category',
    sku: 'Sku',
    containerNumber: 'Container Number',
    features: 'Features'
  },
  OrderDeliveryTimeOverviewOrDetail:{
    orderCreateTime: 'Order Create Time',
    orderOccupationTime: 'Order Occupancy Time',
    custom: 'Custom',
    cycleConditions: 'Cycle Conditions',
    orderA2Delivery: 'PI Issued → Shipped',
    orderD2Delivery: 'PI Confirmed → Shipped',
    month: 'Month',
    day: 'Day',
    invalidDateRange:'Invalid Date Range',
    title1: 'Trend Of Average Delivery Time Shipped (Unit: Days)',
    figure1: 'Average Delivery Time',
    title2: 'Delivery Period Distribution (Unit: Odd Number)',
    figure2: 'Delivery Period Segmentation',
    orderId: 'PI NO',
    totalDeliveryTime: 'Total Delivery Time',
    deliveryOrNot: 'Whether To Ship',
    orderCreareDate:'PI Create Date',
    firstDeliveryDate:'First Delivery Date',
    currentStatus:'Current Status',
    orderA2C: 'PI Issued → Signed',
    orderC2D: 'PI Signed → Confirmed',
    reviewDateD:'Review PI Confirmed Date',
    orderD2ExpectedCompleted:'PI Confirmed → Expected Finished',
    orderD2Completed: 'PI Confirmed → Finished',
    orderCompleted2Vanning: 'Finished → Loaded',
    orderCompleted2Delivery: 'Finished → Shipped',
    total: 'Total',
    haveSigned:'Have Signed',
    siteValidation:'Site Validation',
    inTheProduction:'In The Production',
    haveBeenCompleted:'Have Been Completed',
    installedCabinet:'Installed Cabinet',
    hasBeenShipped:'Has Been Shipped',
  },
  CompetitiveProductAnalysisPage: {
    tup:'Total Upload Progress ',
    tur:'Total Upload Rate',
    nonCollaborated:'Non collaborated',
    collaborated:'Collaborated',
    to:'to',
    table:{
      title1:'Competitive Analysis',
      title2:'Start Date',
      title3:'End Date',
      title4:'Total Accounts',
      handle:'Operation',
      insert:'Add Information',
      view: 'View',
      division: 'Division',
      totalCustomerCount: 'Total Customer Count',
      competitorCustomersUploaded: 'Competitor Customers Uploaded',
      competitorCustomersNotUploaded: 'Competitor Customers Not Uploaded',
      uploadRate: 'Upload Rate',
      newRate:'Upload Progress',
    },
    materialList:"Please Select The Cover",
    gradeList:"Please Select The Grade",
    categoryList:"Please Select The Category",
    priceBandList:'Please Select A Price Range(Retail Price $)',
    selectTips:"Please Select",
    viewUploadedCompetitiveProductInformation: 'View Uploaded Company Competitors Information'
  },
  CompetitiveProductAnalysisDataListPage:{
    country: 'Country/Area',
    customerName:'Customer Name',
    vp:'VP',
    sales:'Sales Rep',
    competitorNum:'Upload QTY',
    recentUploadTime:'Last Update Time',
    uploader:'Uploader',
    handle:'Operation',
    save:'Add/Edit Competition',
    inset: 'Add Competitor',
    addCompany: 'Add Company',
    editCompany: 'Edit Company',
    view:'View Competitor',
    cd:'Line Up & Competition',
    lastEditDate: 'Last Edit Date',
    uploadDate: 'Upload Date',
    exportCompetingProducts: 'Export Company Competitior'
  },
  CompetitiveProductAnalysisStylePage: {
    company: 'Company',
    Currency:'Currency',
    exhibitionPrice:'Exhibition Price',
    covers:'Covers List',
    pdc:"Product Class",
    displaySection: 'Display',
    tableSection: 'Table',
    search:'search',
    add:'Add',
    update:'Update',
    delete:'Delete',
    no:'no',
    yes:'yes',
    filterPlaceholder:'Filter',
    addFrame:'Add Frame',
    category: 'Category',
    image: 'Main Image',
    images:'Side Image',
    vendor: 'Supplier',
    price: 'Retail Price',
    cover: 'Cover',
    function: 'Function',
    arrangementType: 'Arrangement Type',
    productName: 'Product Name',
    notes: 'Notes',
    onlineOnly: 'OnlineOnly',
    classification: 'Category',
    types: 'Types',
    newFunctions: 'New Functions',
    features: 'Features',
    dimensionType: 'Dimension',
    salesType: 'Status',
    column: 'Sku',
    floorDisplayNumber: 'Floor Display Number',
    fobPrice: 'FOB Price',
    priceRange: 'Price Range($)',
    customer: 'Customer',
    model: 'Model No.',
    type: 'Type',
    size: 'Size（W*D*H）',
    leve: 'Level',
    dragUploadText: 'Drop file here, or',
    clickUpload: 'click to upload',
    uploadTip: 'Only jpg/png files can be uploaded, and no more than {size}MB',
    uploadImageFormatError: 'Only jpg/png image files can be uploaded',
    uploadImageSizeError: 'Upload file size cannot exceed {size}MB',
    uploadExceedLimit: 'You can upload up to {limit} files',
    uploadFailed: 'Upload failed'
  },
  OrderIntake:{
    vpSales: 'VP/Sales',
    customerName: 'Customer',
    style: 'Model',
    color: 'Color',
    status: 'Status',
    monthDate: 'Estimated Ready Date',
    subtotal: 'Sub Total',
    total: 'Total',
    spec: 'Spec.',
    orderNum: 'OrderNum',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    bookDate: 'Book Date',
    salesOrder: 'Sales Order',
    customerOrderNumber: 'Customer Order Number',
    occupancyDate: 'Occupancy Date',
    ordersReceivedLastMonth: 'Orders Received Last Month',
    numberOfDisplaySetups: 'Number Of Display Setups',
    TooC: 'Total 0per Order Cnty',
    lastMonthShipments: 'Last Month Shipments',
    currentMonthDeliveries: 'Current Month Deliveries'
  },
  productRecommendation: {
    Division: 'Division',
    vpSales: 'VP/Sales',
    customer: 'Customer',
    style: 'Style',
    businessId: 'Business No.',
    material: 'Cover',
    category: 'Category',
    level: 'Level',
    model: 'Model',
    specification: 'SKU',
    fabric: 'Fabric',
    color: 'Color',
    size: 'Size',
    functionFeatures: 'Function Features',
    price: 'Price （$）',
    recommendedReason: 'Recommended Reason',
    recommendedPriority: 'Recommended Priority',
    followRecords: 'Follow Records',
    exportProductRecommendationTemplate: '{t} Template',
    importProductRecommendationTableInformation: '{t} Proposal Info',
    exportProductRecommendationTable: '{t} Proposal list',
    exportProductRecommendationScheme: '{t} Proposal plan',
    required: 'Required'
  },
  MainPushStyleSalesRanking: {
    department: 'Division',
    levelRanking: 'Level Ranking',
    type: 'Cover',
    category: 'Category',
    level: 'Level',
    categoryRanking: 'Category Ranking',
    model: 'Model',
    running: 'Running',
    fobPrice: 'Fob Price',
    netSales: 'Net sales for {t}',
    cumulativeNetSales: 'Cumulative net sales for the past six months',
    orderQuantityInIheNext3months: 'Order quantity in the next 3 months  ({t})',
    customer: 'Customer',
    numbersOfDisplay: 'Numbers Of Display',
    picture: 'Picture',
    mark: 'Mark',
    recommendedStatus: 'Recommended Status',
    ferth: 'Ferth',
    color: 'Color',
    fandm:"SKU/Code"
  },
  ContainerDimensions: {
    materialNo: 'Material No.',
    packageSize: 'Package Size:{t}(in)',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    dialogTitle: '{t} (units:in)',
    uprightPosition: 'Upright Position',
    onSidePosition: 'On Side Position',
    flatPosition: 'Flat Position',
    uprightWithHorizontalRotation: 'Upright With Horizontal Rotation',
    onSideWithHorizontalRotation: 'On Side With Horizontal Rotation',
    flatWithHorizontalRotation: 'Flat With Horizontal Rotation',
    permitted: 'Permitted',
    mixedStackingAllowed: 'Mixed Stacking Allowed',
    stackingTiers: 'Stacking Tiers',
    allowed: 'Allowed?',
    placementMethod: 'Placement method',
    tips: 'Instructions: If there are no special restrictions, the following options can be left blank. If special restrictions exist, select "No" in the corresponding "Is this placement method allowed?" option. For placing other types of goods on top, select "Not allowed". For stacking layers, enter the maximum allowed number of layers using a numeric value.',
    no: 'No',
    notAllowed: 'Not Allowed'
  },
  AccountHierarchySettings: {
    name: 'Name',
    account: 'Account',
    searchPlaceholder: 'Please enter',
    employeeAccount: 'Employee Account',
    employeeName: 'Employee Name',
    email: 'Email',
    directSuperiorAccount: 'Direct Superior Account',
    directSuperiorName: 'Direct Superior Name ',
    directSuperiorEmail: 'Direct Superior Email',
    skipLevelLeaderAccount: 'Skip-Level Leader Account',
    skipLevelLeaderName: 'Skip-Level Leader Name',
    skipLevelLeaderEmail: 'Skip-Level Leader Email',
    isThereASkipLevelLeader: 'Is There A Skip Level Leader',
    no: 'No',
    yes: 'Yes',
    dialogTitle: '{t} Employee Hierarchy'
  },
  ExReservationInvitationSummary:{
    title: 'Market Invitations Summary Table',
    division: 'Division',
    totalNumberOfClients: 'Total Number Of Customer',
    plannedInvitationRate:'Planned Invitation Rate',
    plannedInvitationRateForCurrentExhibition: 'Planned Invitation Rate Of Current Market',
    plannedNumberOfClientsToInvite: 'Planned Number Of Customer To Invite',
    numberOfClientsDecliningAttendance: 'Number Of Customer Declining Attendance',
    numberOfClientsInvited: 'Number Of Customer Invited',
    invitationAchievementRate: 'Invitation Achievement Rate',
    numberOfClients: 'Number Of Customer',
    numberOfCollaboratedClients: 'Number Of Collaborated Customer',
    numberOfNonCollaboratedClients: 'Number Of Non Collaborated Customer',
    totalPlannedInvitations: 'Total Planned Invitations',
    totalInvitationsCompleted: 'Total Completion Invitations',
    achievementRate: 'Achievement Rate'
  },
  ToDoReminder: {
    marketsRelated: 'Markets Related',
    orderRelated: 'Order Related',
    competingProductsRelated: 'Company Competitior Related',
    otherRelated: 'Other Related'
  }
};
